module.exports = __webpack_public_path__ + "static/media/intro-img.558f44ca.jpg";